import React, { useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import useContain from 'react-contain-textbox';

const useStyles = makeStyles((theme) => ({
	root: {
		borderRadius: theme.spacing(1),
		color: '#eee',
	},
}));

export default function Player(props) {
	const { className, pid } = props;
	const ref = useRef();

	const classes = useStyles();

	const resize = useContain(ref);

	useEffect(() => {
		resize();
	}, [resize, pid]);

	return (
		<div
			ref={ref}
			className={clsx(classes.root, className)}
		>
			{pid}
		</div>
	);
}

Player.defaultProps = {
	className: undefined,
};

Player.propTypes = {
	className: propTypes.string,
	pid: propTypes.string.isRequired,
};
